import { persistCombineReducers } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import wrapperReducer from './../routes/Wrapper/reducer';
import loginReducer from './../components/Login/reducer';
import systemDashboardReducer from './../components/SystemDashboard/reducer';
import maintHistReducer from './../components/MaintenanceHistory/reducer';
import woHeaderReducer from './../components/WorkOrders/Header/reducer';
import woDashboardReducer from './../components/WorkOrders/Dashboard/reducer';
import workOrderReducer from './../components/WorkOrders/WorkOrder/reducer';
import kanbanBoardReducer from './../components/Kanban/Board/reducer';
import cycleSheetsReducer from './../components/CycleCounts/CountSheets/reducer';
import calendarReducer from './../components/CycleCounts/Calendar/reducer';

const config = {
    key: 'root',
    storage,
};

const appReducers = persistCombineReducers(config, {
    wrapperReducer,
    loginReducer,
    systemDashboardReducer,
    maintHistReducer,
    woHeaderReducer,
    woDashboardReducer,
    workOrderReducer,
    kanbanBoardReducer,
    cycleSheetsReducer,
    calendarReducer
});

const reducers = (state, action) => {
    if (action.type == 'USER_LOGOUT') {
        // state = undefined;
    }
    return appReducers(state, action);
}

export default reducers;